import {
  MissingManifestDownloadResponse,
  MissingManifestUIResponse,
} from "../../models/ApiResponse";
import { MissingManifestResponse } from "../../models/responseModels/missingManifestResponse";
import { axiosRequests } from "../axiosRequest";

export const MissingManifestAgent = {
  getMissingManifestList: () =>
    axiosRequests.get<MissingManifestUIResponse>(
      "/missingManifest/GetMissingManifestList"
    ),
  missingManifestCsvDownload: (
    MissingManifestData: MissingManifestResponse[]
  ) =>
    axiosRequests.post<MissingManifestDownloadResponse>(
      "/missingManifest/DownloadCsv",
      MissingManifestData
    ),
  missingManifestXlsxDownload: (
    MissingManifestData: MissingManifestResponse[]
  ) =>
    axiosRequests.postXlsx<Blob>(
      "/missingManifest/DownloadXlsx",
      MissingManifestData
    ),
};
